import { useSite } from "../context/SiteContentContext";
import { MapPin, Phone, Mail, Clock, Instagram } from "lucide-react";

export const Location = () => {
    const siteConfig = useSite();
    const { contact, hours } = siteConfig;

    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#121212] border-t border-[#262626]"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    <div className="lg:col-span-5">
                        <div className="ornamental-divider mb-6">
                            <span>Encontra-nos</span>
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-none text-[#f5f5f0] mb-10">
                            Onde. Quando.
                            <br />
                            <span className="italic font-normal text-[#a3a3a3]">
                                Como.
                            </span>
                        </h2>

                        <div className="space-y-6 mb-10">
                            <InfoRow
                                icon={<MapPin size={18} />}
                                label="Morada"
                                value={contact.address}
                            />
                            <InfoRow
                                icon={<Phone size={18} />}
                                label="Telefone"
                                value={contact.phone}
                                href={`tel:${contact.phone.replace(/\s/g, "")}`}
                            />
                            {contact.email && (
                                <InfoRow
                                    icon={<Mail size={18} />}
                                    label="Email"
                                    value={contact.email}
                                    href={`mailto:${contact.email}`}
                                />
                            )}
                            <InfoRow
                                icon={<Instagram size={18} />}
                                label="Instagram"
                                value={contact.instagramHandle}
                                href={contact.instagram}
                                external
                            />
                        </div>

                        <div className="border-t border-[#262626] pt-8">
                            <div className="flex items-center gap-3 text-[#d4af37] mb-5">
                                <Clock size={16} />
                                <span className="text-xs tracking-widest uppercase font-medium">
                                    Horário
                                </span>
                            </div>
                            <ul className="space-y-3">
                                {hours.map((h) => (
                                    <li
                                        key={h.days}
                                        className="flex items-baseline justify-between gap-4 font-body"
                                    >
                                        <span className="text-[#f5f5f0]">
                                            {h.days}
                                        </span>
                                        <span className="leader" />
                                        <span className="text-[#a3a3a3] tabular-nums">
                                            {h.time}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div
                            className="relative aspect-[4/3] overflow-hidden border border-[#262626]"
                            data-testid="contact-map"
                        >
                            <iframe
                                title="Mapa"
                                src={contact.mapsEmbed}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                className="w-full h-full"
                                style={{
                                    border: 0,
                                    filter: "invert(92%) hue-rotate(180deg) brightness(0.9) contrast(0.95)",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const InfoRow = ({ icon, label, value, href, external }) => {
    const content = (
        <>
            <div className="text-[#d4af37] mt-0.5">{icon}</div>
            <div>
                <div className="text-xs tracking-widest uppercase text-[#737373] mb-1">
                    {label}
                </div>
                <div className="text-[#f5f5f0] font-body">{value}</div>
            </div>
        </>
    );
    if (href) {
        return (
            <a
                href={href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                className="flex items-start gap-4 group hover:opacity-80 transition-opacity"
            >
                {content}
            </a>
        );
    }
    return <div className="flex items-start gap-4">{content}</div>;
};
